module.exports = __webpack_public_path__ + "static/img/wap.1dd022b.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/cn/北京通州华仁学校/wap.svg
// module id = TKZT
// module chunks = 16